function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M136.313,119.656A62.656,62.656,0,1,1,73.656,57,62.656,62.656,0,0,1,136.313,119.656Z",
  transform: "translate(34.948 181.094)",
  fill: "#ff9b37"
}), /*#__PURE__*/React.createElement("path", {
  d: "M238.008,82.934,288.969,9,131.91,166.058,238.426,18.19,131.91,129.3l27.569-50.96L94.734,152.274l9.19-27.569L20.8,195.716a75.724,75.724,0,0,1,21.721-2.924,79.329,79.329,0,0,1,79.365,79.365,84.528,84.528,0,0,1-5.43,29.24l84.795-93.567-22.974,4.595,64.745-55.555L187.048,180.26,270.59,96.719l-60.15,37.176,78.529-83.124Z",
  transform: "translate(66.083 28.594)",
  fill: "#fc0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M60.015,41.086c3.342,2.089,7.936.418,10.025-3.759,2.924-5.012,2.506-4.177,5.848-24.227,0,0-15.455,12.949-17.961,17.126C56.255,34.4,56.673,39,60.015,41.086Z",
  transform: "translate(181.003 41.62)",
  fill: "#fc0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M71.292,68.55c2.089,3.342,6.683,3.759,10.86,1.253C85.912,67.3,106.38,48.5,106.38,48.5s-27.986,7.1-31.746,9.607S69.2,65.626,71.292,68.55Z",
  transform: "translate(223.61 154.089)",
  fill: "#fc0"
}));

function SvgMeteoro(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 401,
    height: 401,
    viewBox: "0 0 401 401",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeteoro);
export default __webpack_public_path__ + "static/media/meteoro.b274474a.svg";
export { ForwardRef as ReactComponent };